// extracted by mini-css-extract-plugin
export default {"ErrorPage":"Unauthorized_ErrorPage__JbXkd","AllElements":"Unauthorized_AllElements__4-3P9"};